import { ClockCircleOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, InputNumber, Spin } from 'antd';
import HeaderMenu from 'components/Header/HeaderMenu';
import HistoryPredictions from 'components/HistoryPredictions';
import { SITE } from 'config/config';
import userIcon from 'assets/images/home/user.svg';
import dayjs from 'dayjs';
import qs from 'query-string';
import React, { useCallback, useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import {
  createPredictions,
  getAllSetting,
  getFP,
  getIP,
  getMatchList,
  getTime
} from 'service/base';
import { twMerge } from 'tailwind-merge';
import { CONST_SITE } from 'utils/common/const';

const leagues = [
  {
    id: 1,
    name: 'UEFA Champions League',
    logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/f/f5/UEFA_Champions_League.svg/960px-UEFA_Champions_League.svg.png'
  },
  {
    id: 2,
    name: 'UEFA Europa League',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/1/1b/UEFA_Europa_League_logo_%282024_version%29.svg'
  },
  {
    id: 3,
    name: 'Premier League',
    logo: 'https://loodibee.com/wp-content/uploads/Premier-League-Logo.png'
  },
  {
    id: 4,
    name: 'La Liga',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776497700383-85707437.png'
  },
  {
    id: 5,
    name: 'Serie A',
    logo: 'https://1000logos.net/wp-content/uploads/2019/01/Italian-Serie-A-Logo.png'
  },
  {
    id: 6,
    name: 'Bundesliga',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776497741004-506738821.png'
  },
  {
    id: 7,
    name: 'League One',
    logo: 'https://api-ddts-on68.attcloud.org/public/uploads/file-1776497881490-491170157.png'
  },
  {
    id: 8,
    name: 'FIFA World Cup',
    logo: 'https://att-bucket.sgp1.cdn.digitaloceanspaces.com/logo/wc-2026.png'
  }
];

const CM88Page = () => {
  const [isModalHistory, setIsModalHistory] = useState(false);
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [listDataMatch, setListDataMatch] = useState([]);
  const [timeServer, setTimeServer] = useState(null);
  const [IP, setIP] = useState(null);
  const [FP, setFP] = useState(null);
  const [dataSettings, setDataSettings] = useState([]);

  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'today', 'tomorrow'
  const [showSchedulePopup, setShowSchedulePopup] = useState(false);

  // Hàm lọc trận đấu theo tab được chọn
  const getFilteredMatches = () => {
    if (!listDataMatch || listDataMatch.length === 0) return [];

    const now = dayjs();
    const today = now.format('YYYY-MM-DD');
    const tomorrow = now.add(1, 'day').format('YYYY-MM-DD');

    switch (activeTab) {
      case 'today':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === today;
        });
      case 'tomorrow':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === tomorrow;
        });
      case 'all':
      default:
        return listDataMatch;
    }
  };

  const handleLeagueClick = (leagueId) => {
    setSelectedLeagues((prevSelectedLeagues) =>
      prevSelectedLeagues.includes(leagueId)
        ? prevSelectedLeagues.filter((id) => id !== leagueId)
        : [...prevSelectedLeagues, leagueId]
    );
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const leagueListRef = React.createRef();

  const scrollLeft = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft - 100);
    }
  };

  const scrollRight = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft + 100);
    }
  };

  useEffect(() => {
    fetchAllSetting();
    fetchIP();
    fetchFP();
    fetchTimeServer();
  }, []);

  const fetchDataScheduByLS = useCallback(async () => {
    try {
      setIsLoading(true);
      const res2 = await getMatchList({
        site: CONST_SITE.CM88
      });

      const dataMatch2 =
        res2?.data?.length > 0
          ? res2.data.map((item) => {
              const formatCountDown = dayjs.unix(item.startTime);
              return { ...item, countdown: new Date(formatCountDown) };
            })
          : [];

      setListDataMatch(dataMatch2 || []);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching match list:', error);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDataScheduByLS();
    const intervalMs = 5 * 60 * 1000;
    const timerId = window.setInterval(fetchDataScheduByLS, intervalMs);
    // Load saved account from localStorage
    const savedAccount = localStorage.getItem('saved_account');
    if (savedAccount) {
      form.setFieldsValue({ account: savedAccount });
    }
    return () => window.clearInterval(timerId);
  }, [form, fetchDataScheduByLS]);

  const fetchIP = async () => {
    try {
      const res = await getIP();
      setIP(res);
    } catch (e) {}
  };

  const fetchFP = async () => {
    try {
      const res = await getFP();
      setFP(res);
    } catch (e) {}
  };

  const fetchTimeServer = async () => {
    try {
      const res = await getTime();
      setTimeServer(res);
    } catch (e) {}
  };

  const fetchAllSetting = async (data) => {
    try {
      setIsLoading(true);
      const res = await getAllSetting(qs.stringify({ site: CONST_SITE.CM88 }));
      setDataSettings(res?.data || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const TIMEOUT_DURATION = 10000; // 10 seconds

  const createPredictionsWithTimeout = (predictions) => {
    return Promise.race([
      createPredictions(predictions),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), TIMEOUT_DURATION)
      )
    ]);
  };

  const onFinishForm = async (data) => {
    try {
      const filteredMatches = getFilteredMatches();
      if (filteredMatches?.length === 0) return;

      if (!data?.account) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đăng nhập!'
        });
        return;
      }

      // Validate that both home and away scores are provided for each match
      const hasInvalidScores = Object.entries(data).some(([key, value]) => {
        // Bỏ qua field account và các field không phải score
        if (key === 'account' || !key.includes('_')) return false;

        const parts = key.split('_');
        if (parts.length !== 2) return false;

        const [scoreType, matchId] = parts;
        if (!['homeScore', 'awayScore'].includes(scoreType)) return false;

        const otherScoreType = scoreType === 'homeScore' ? 'awayScore' : 'homeScore';
        const otherScoreKey = `${otherScoreType}_${matchId}`;
        const otherValue = data[otherScoreKey];

        // Kiểm tra nếu một trong hai score có giá trị nhưng score kia không có
        const hasValue = value !== undefined && value !== null && value !== '';
        const hasOtherValue = otherValue !== undefined && otherValue !== null && otherValue !== '';

        if (hasValue && !hasOtherValue) {
          return true;
        }

        return false;
      });

      if (hasInvalidScores) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập đầy đủ cả hai bên tỉ số cho mỗi trận đấu!'
        });
        return;
      }

      setIsLoadingSubmit(true);

      console.log('filteredMatches', filteredMatches);
      const resultGroup = groupScoresByMatchId(data, IP, FP, filteredMatches);

      if (resultGroup.length === 0) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng điền đẩy đủ thông tin và dự đoán ít nhất một trận đấu!'
        });
        setIsLoadingSubmit(false);
        return;
      }

      console.log('resultGroup.length', resultGroup?.length);
      if (resultGroup?.length > 6) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Bạn chỉ được chọn tối đa 6 trận đấu dự đoán 1 ngày!'
        });
        setIsLoadingSubmit(false);
        return;
      }

      const res = await createPredictionsWithTimeout(resultGroup);
      if (res?.code === 0) {
        // Lưu account vào localStorage
        if (data?.account) {
          localStorage.setItem('saved_account', data.account);
        }
        notification.success({
          message: 'Thành công',
          description: 'Dự đoán tỉ số thành công!'
        });
        form.resetFields(Object.keys(form.getFieldsValue()).filter((key) => key !== 'account'));
      } else {
        if (res.valid === false) {
          notification.error({
            message: res.title_mess,
            description: res?.text_mess
          });
        } else {
          notification.error({
            message: 'Lỗi',
            description: res?.message
          });
        }
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      notification.error({
        message: 'Lỗi',
        description: error.message || 'Đã xảy ra lỗi khi gửi dự đoán!'
      });
      setIsLoadingSubmit(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    if (!errorInfo?.values?.account) {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng nhập tên đang nhập!'
      });
    } else {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng điền đầy đủ thông tin!'
      });
    }
  };

  const groupScoresByMatchId = (input, ip, fp, matchInfo) => {
    const groupedMatches = Object.entries(input).reduce((acc, [key, value]) => {
      if (key === 'account') return acc;

      const parts = key.split('_');
      if (parts.length !== 2) return acc;

      const [scoreType, matchId] = parts;
      if (!matchId || !['homeScore', 'awayScore'].includes(scoreType)) return acc;

      // Kiểm tra giá trị hợp lệ
      if (value === undefined || value === null || value === '') return acc;

      if (!acc[matchId]) {
        acc[matchId] = {
          matchId,
          account: input.account,
          homeScore: undefined,
          awayScore: undefined
          // sameScore: undefined
        };
      }

      if (scoreType === 'homeScore') {
        acc[matchId].homeScore = value;
      } else if (scoreType === 'awayScore') {
        acc[matchId].awayScore = value;
      }
      // else if (scoreType === 'sameScore') {
      //   acc[matchId].sameScore = value;
      // }

      return acc;
    }, {});

    return Object.values(groupedMatches)
      .filter(
        (match) =>
          match.homeScore !== undefined &&
          match.awayScore !== undefined &&
          // match.sameScore !== undefined &&
          match.homeScore !== null &&
          match.awayScore !== null &&
          // match.sameScore !== null &&
          match.homeScore !== '' &&
          // match.sameScore !== '' &&
          match.awayScore !== ''
      )
      .map(({ matchId, account, homeScore, awayScore }) => {
        const matchDetails = matchInfo.find(
          (match) => parseInt(match.matchId) === parseInt(matchId)
        );

        return {
          matchId,
          homeScore,
          awayScore,
          // sameScore,
          account,
          ip,
          fp,
          homeName: matchDetails ? matchDetails.homeName : 'Unknown',
          awayName: matchDetails ? matchDetails.awayName : 'Unknown',
          site: SITE
        };
      });
  };

  const showListItemMatch = (matchList) => {
    if (!matchList || matchList.length <= 0) {
      return (
        <div className="flex items-center justify-center max-w-[1200px] xl:w-3/4 md:w-4/5 w-full mx-auto backdrop-blur-[30px] rounded-2xl px-1 sm:px-2 py-5 mt-3 text-center p-5 border-[1.8px] border-solid border-[#36A638]">
          <p className="text-center">Hiện tại không có trận đấu nào để dự đoán</p>
        </div>
      );
    } else {
      const filteredMatchList =
        selectedLeagues.length > 0
          ? matchList.filter((item) =>
              selectedLeagues.includes(
                leagues.find(
                  (league) =>
                    league.name === item.leagueName || item.leagueName.startsWith(league.name)
                )?.id
              )
            )
          : matchList;

      const scoreCircleInputClassName =
        '!flex !h-full !w-full !min-h-0 !min-w-0 !border-0 !bg-transparent !p-0 !shadow-none [&_.ant-input-number-input]:!h-full [&_.ant-input-number-input]:!min-h-0 [&_.ant-input-number-input]:!rounded-full [&_.ant-input-number-input]:!border-0 [&_.ant-input-number-input]:!bg-transparent [&_.ant-input-number-input]:!px-0.5 [&_.ant-input-number-input]:!text-center [&_.ant-input-number-input]:!text-[11px] [&_.ant-input-number-input]:!leading-none [&_.ant-input-number-input]:!text-[#505050] sm:[&_.ant-input-number-input]:!text-sm';
      const getMatchStartMs = (match) => {
        const countdown = Number(match?.countdown);
        if (Number.isFinite(countdown)) return countdown;
        const startTime = Number(match?.startTime);
        return Number.isFinite(startTime) ? startTime * 1000 : Number.MAX_SAFE_INTEGER;
      };

      const itemMatch = filteredMatchList
        .filter((item) => timeServer <= item.countdown) // Filter out matches that have ended
        .sort((a, b) => getMatchStartMs(a) - getMatchStartMs(b))
        .map((item, index) => {
          // const matchDayOfWeek = daysOfWeek[dayjs(item.startTime * 1000).format('dddd')]; // Calculate day of week for each match
          return (
            <div
              className="flex w-full min-w-0 flex-col items-stretch rounded-[22px] border-[2.8px] border-solid border-[#36A638] bg-[#FEFEFE] px-3 pb-3 pt-0 font-medium"
              key={index}
            >
              <div className="mx-auto mt-0 flex w-full max-w-[320px] justify-center rounded-b-[28px] bg-[#36A638] px-4 py-[8px]">
                <p className="text-center font-roboto text-[13px] font-bold leading-[1.15] text-white sm:text-[15px] md:text-[16px]">
                  {item?.leagueName}
                </p>
              </div>

              <div className="mt-3 flex items-center justify-center gap-1.5 px-2">
                <ClockCircleOutlined className="shrink-0 text-[18px] text-[rgba(69,69,69,0.83)] sm:text-[21px]" />
                <span className="flex flex-wrap items-center gap-x-1 font-roboto text-[14px] leading-[1.15] text-[rgba(69,69,69,0.83)] sm:text-[16px]">
                  <span>Thời gian còn:</span>
                  <Countdown
                    date={item.countdown}
                    renderer={({ days, hours, minutes, seconds, completed }) => {
                      if (completed) {
                        return <span className="font-normal">00:00:00</span>;
                      }
                      const pad = (n) => n.toString().padStart(2, '0');
                      const totalHours = days * 24 + hours;
                      return (
                        <span className="font-normal text-[rgba(69,69,69,0.83)]">
                          {pad(totalHours)}:{pad(minutes)}:{pad(seconds)}
                        </span>
                      );
                    }}
                  />
                </span>
              </div>

              <div className="mt-2 flex w-full gap-2 px-3 sm:flex-row sm:items-center justify-between sm:gap-4 md:px-[18px]">
                <span
                  className="text-[14px] font-semibold uppercase leading-[1.21] text-[#5F5F5F] sm:text-[16px]"
                  style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
                >
                  {dayjs(item.countdown).format('HH:mm DD/MM/YYYY')}
                </span>
                <span className="font-roboto text-[14px] font-normal leading-[1.15] text-[#5F5F5F] sm:text-[16px]">
                  Thời gian diễn ra:{' '}
                  <span className="whitespace-nowrap">
                    {dayjs(item.startTime * 1000).format('HH:mm')}
                  </span>
                </span>
              </div>

              <div className="mt-2 flex flex-wrap items-center justify-center md:gap-2 gap-1">
                <div className="flex h-[44px] min-w-0 max-w-[min(100%,280px)] flex-1 items-center overflow-hidden rounded-[10px_22px_22px_10px] bg-[#36A638]">
                  <p className="line-clamp-2 min-h-0 min-w-0 flex-1 break-words px-2 py-0 pr-1 text-right font-roboto text-[11px] font-medium leading-tight text-white sm:px-2 sm:text-[12px]">
                    {item.homeName}
                  </p>
                  <div className="h-[42px] w-[42px] mr-[2px] shrink-0 overflow-hidden rounded-full bg-white">
                    <img
                      src={item.homeLogo}
                      className="h-full w-full object-contain p-0.5"
                      alt=""
                    />
                  </div>
                </div>

                <div className="flex h-[44px] shrink-0 items-center gap-1 rounded-full bg-gradient-to-b from-[#36A638] to-[#45E026] px-1">
                  <div className="flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full bg-white">
                    <Form.Item
                      className="m-0 mb-0 flex h-full w-full items-center justify-center [&_.ant-form-item-control-input]:!min-h-0 [&_.ant-form-item-row]:!w-full"
                      name={`homeScore_${item.matchId}`}
                    >
                      <InputNumber
                        disabled={timeServer > item.countdown}
                        controls={false}
                        min={0}
                        max={99}
                        maxLength={2}
                        placeholder="0"
                        className={scoreCircleInputClassName}
                        style={{
                          fontFamily: "'Roboto', sans-serif"
                        }}
                      />
                    </Form.Item>
                  </div>
                  <span className="font-roboto text-lg font-medium leading-none text-white sm:text-xl">
                    :
                  </span>
                  <div className="flex h-[40px] w-[40px] shrink-0 items-center justify-center overflow-hidden rounded-full bg-white">
                    <Form.Item
                      className="m-0 mb-0 flex h-full w-full items-center justify-center [&_.ant-form-item-control-input]:!min-h-0 [&_.ant-form-item-row]:!w-full"
                      name={`awayScore_${item.matchId}`}
                    >
                      <InputNumber
                        disabled={timeServer > item.countdown}
                        controls={false}
                        min={0}
                        max={99}
                        maxLength={2}
                        placeholder="0"
                        className={scoreCircleInputClassName}
                        style={{
                          fontFamily: "'Roboto', sans-serif"
                        }}
                      />
                    </Form.Item>
                  </div>
                </div>

                <div className="flex h-[44px] min-w-0 max-w-[min(100%,280px)] flex-1 items-center overflow-hidden rounded-[22px_10px_10px_22px] bg-[#36A638]">
                  <div className="h-[42px] w-[42px] ml-[2px] shrink-0 overflow-hidden rounded-full bg-white">
                    <img
                      src={item.awayLogo}
                      className="h-full w-full object-contain p-0.5"
                      alt=""
                    />
                  </div>
                  <p className="line-clamp-2 min-h-0 min-w-0 flex-1 break-words px-2 py-0 pl-1 text-left font-roboto text-[11px] font-medium leading-tight text-white sm:px-2 sm:text-[12px]">
                    {item.awayName}
                  </p>
                </div>
              </div>

              <div className="hidden mt-4 flex w-full justify-center">
                <Button
                  type="none"
                  htmlType="submit"
                  className="h-[38px] w-[140px] border-0 bg-transparent shadow-none hover:scale-105 hover:bg-transparent focus:bg-transparent sm:h-[40px] sm:w-[163px] md:h-[44px] md:w-[163px]"
                  style={{
                    backgroundImage: `url(assets/images/match/btn_send.png)`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }}
                />
              </div>
            </div>
          );
        });

      if (!itemMatch || itemMatch.length <= 0) {
        return (
          <div className="flex items-center justify-center max-w-[1200px] xl:w-3/4 md:w-4/5 w-full mx-auto backdrop-blur-[30px] rounded-2xl px-1 sm:px-2 py-5 mt-3 text-center p-5 border-[1.8px] border-solid border-[#36A638]">
            <p className="text-center">Hiện tại không có trận đấu nào để dự đoán</p>
          </div>
        );
      }
      return (
        <div className="max-w-[1200px] xl:w-3/4 md:w-4/5 w-full mx-auto mt-3 grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-4">
          {itemMatch}
        </div>
      );
    }
  };

  return (
    <div className="w-full min-h-full flex flex-col">
      <div className="relative z-10">
        {/* <Header /> */}
        <HeaderMenu />
        <div className="relative mx-4 mb-4 overflow-hidden rounded-[8px] border border-solid border-[#36A638] bg-white/25 px-2 py-3">
          <div className="flex space-x-6 mt-1 lg:mt-3 justify-center items-center">
            <Button
              type="link"
              icon={<LeftOutlined />}
              onClick={scrollLeft}
              className="text-[#36A638] !px-0 !mx-0"
            />
            <div
              className="flex overflow-x-auto scrollbar-hide pt-1 pb-2 !mx-0"
              ref={leagueListRef}
              style={{ scrollBehavior: 'smooth' }}
            >
              {leagues.map((league) => (
                <div
                  key={league.id}
                  className={twMerge(
                    'flex justify-center items-center p-1 mx-2 rounded-lg cursor-pointer transition-all duration-300 hover:scale-105',
                    selectedLeagues.includes(league.id)
                      ? 'bg-black/15 shadow-lg shadow-[#36A638] border-2 border-[#36A638]'
                      : 'bg-white/80 backdrop-blur-sm border-2 border-[#36A638]/30 hover:border-[#36A638] hover:shadow-md'
                  )}
                  style={{ width: '80px', minWidth: '80px', border: '1px solid #36A638' }}
                  onClick={() => handleLeagueClick(league.id)}
                >
                  <img src={league.logo} alt={league.name} className="h-12 object-contain" />
                </div>
              ))}
            </div>
            <Button
              type="link"
              icon={<RightOutlined />}
              onClick={scrollRight}
              className="text-[#36A638] !px-0 !mx-0"
            />
          </div>
          <Form
            name="formMatch"
            onFinish={onFinishForm}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            form={form}
            initialValues={{ account: '' }}
          >
            <div className="mx-auto mt-1 flex w-full max-w-[332px] items-center gap-[10px]">
              <Form.Item
                name="account"
                className="mb-0 min-w-0 flex-1"
                rules={[{ required: true, message: 'Vui lòng điền tên đăng nhập!' }]}
              >
                <Input
                  placeholder="Nhập tên đăng nhập ..."
                  maxLength={20}
                  prefix={
                    <img
                      src={userIcon}
                      alt=""
                      width={15}
                      height={15}
                      className="h-[15px] w-[15px]"
                      aria-hidden="true"
                    />
                  }
                  classNames={{
                    affixWrapper: 'h-8 !rounded-[4px] !border-[#36A638] bg-white px-2 shadow-none'
                  }}
                  className="h-8 rounded-[4px] border-[#36A638] bg-white text-[16px] text-[#454545]"
                />
              </Form.Item>
              <Form.Item className="mb-0 shrink-0">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoadingSubmit}
                  className="h-8 w-[104px] rounded-[4px] border-0 bg-[#36A638] text-[12px] font-medium text-white shadow-none"
                >
                  Xác nhận
                </Button>
              </Form.Item>
            </div>

            <div className="mx-auto my-3 flex w-full max-w-[332px] items-center gap-[10px]">
              {[
                { id: 'all', label: 'Tất cả' },
                { id: 'today', label: 'Hôm nay' },
                { id: 'tomorrow', label: 'Ngày mai' }
              ].map((tab) => {
                const isActive = activeTab === tab.id;
                return (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => setActiveTab(tab.id)}
                    className={twMerge(
                      'flex h-[28px] flex-1 items-center justify-center rounded-[4px] p-[5px] text-[12px] font-medium leading-none outline-none transition-colors',
                      isActive
                        ? 'border-0 bg-[#36A638] text-white'
                        : 'border border-solid border-[#36A638] bg-white text-[#36A638]'
                    )}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>

            {isLoading ? (
              <div className="w-full py-8 text-center">
                <Spin />
              </div>
            ) : (
              <div className="mt-1 flex w-full flex-col gap-2">
                {showListItemMatch(getFilteredMatches())}
              </div>
            )}
          </Form>
        </div>
      </div>

      {/* Popup Lịch Thi Đấu */}
      {showSchedulePopup && (
        <div className="fixed inset-y-0 left-1/2 z-50 flex w-full max-w-[430px] -translate-x-1/2 items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-hidden shadow-2xl">
            {/* Header */}
            <div className="flex items-center justify-between p-4">
              <h2 className="text-xl font-bold text-[#  ]">LỊCH THI ĐẤU HOT</h2>
              <button
                onClick={() => setShowSchedulePopup(false)}
                className="w-8 h-8 bg-[#36A638] text-white rounded-full flex items-center justify-center hover:bg-[#36A638] transition-colors"
              >
                ×
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <iframe
                src="https://football-widget.pages.dev/"
                width="100%"
                height="600"
                frameBorder="0"
                allowFullScreen
                title="Football Widget"
                className="w-full rounded-lg"
              />
            </div>
          </div>
        </div>
      )}

      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </div>
  );
};

export default CM88Page;
